var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancelDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MAIN",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(-355.000000, -104.000000)",
    stroke: "#343334",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(356.000000, 105.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -1.8189894e-12,
    x2: 18.408952,
    y2: 18.408952,
    id: "Path-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -1.8189894e-12,
    x2: 18.408952,
    y2: 18.408952,
    id: "Path-7",
    transform: "translate(9.204476, 9.204476) rotate(90.000000) translate(-9.204476, -9.204476) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelDark);
export default __webpack_public_path__ + "static/media/cancel-dark.f4fd8ce90e4664e08ea41763e83bb52d.svg";
export { ForwardRef as ReactComponent };